
import React from 'react';
import { Checkbox } from '@/components/ui/checkbox';

interface InteractiveCheckboxProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  children: React.ReactNode;
  className?: string;
}

export const InteractiveCheckbox = ({ checked, onChange, children, className }: InteractiveCheckboxProps) => {
  return (
    <div className={`flex items-center space-x-2 my-1 ${className}`}>
      <Checkbox 
        checked={checked} 
        onCheckedChange={onChange}
      />
      <label className={`text-sm cursor-pointer ${checked ? 'line-through text-gray-500' : ''}`}>
        {children}
      </label>
    </div>
  );
};
